import React, { useContext, useEffect, useRef, useState } from 'react';

import Content from '../modules/Content';
import Footer from '../modules/Footer';
import Overview from '../modules/Overview';
import Splash from '../modules/Splash';


export default function PageLayout({ post }) {
	
	if (!post) return null;
					
	return (									
		<article className="c-page">
			
			<Splash post={post} />
			<Content post={post} />
			<Footer post={post} />
				
		</article>															
	);
}